import React from 'react'
//Empty component made for later use
function Bills() {
  return (
    <div>Bills</div>
  )
}

export default Bills